import { Injectable } from '@angular/core';
import { RouteService } from './route.service';
import { RestService } from './rest.service';
import { BookConfig } from '../models/book-config';
import { environment } from '../../environments/environment';
import { ApplicationStateService } from './application-state.service';
import { BookAdditionalFactory } from '../models/factories/book-additional-factory';

@Injectable({
    providedIn: 'root'
})
export class BookConfigService {

    constructor(private routeService: RouteService,
                private restService: RestService,
                private applicationStateService: ApplicationStateService) {
    }

    /**
     * Initalize the book config for a book with given id.
     *
     * @param {number} bookId
     * @returns {Promise<BookConfig>}
     */
    init(bookId: number): Promise<BookConfig> {
        if (this.applicationStateService.bookConfig) {
            return new Promise(resolve => {
                resolve(this.applicationStateService.bookConfig);
            });
        }

        const route = this.routeService.getRelativeRoute(environment.endpointUrls.bookConfig, {
            bookId
        });

        return new Promise((resolve, reject) => {
            return this.restService.get(route)
                .then(result => {
                    this.applicationStateService.bookConfig = result;

                    const factory = new BookAdditionalFactory();
                    this.applicationStateService.bookConfig.additionals = this.applicationStateService.bookConfig.additionals.map(ele => {
                        return factory.buildFromObject(ele);
                    });
                    resolve(result);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
